import axios from 'axios';

// Get all locations
export const getLocations = async (filters = {}) => {
  try {
    let queryString = '';
    if (filters.warehouse_id) queryString += `warehouse_id=${filters.warehouse_id}&`;
    if (filters.include_counts) queryString += `include_counts=${filters.include_counts}&`;

    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/locations?${queryString}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching locations' };
  }
};

// Get location by ID
export const getLocationById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/locations/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching location details' };
  }
};

// Get location by barcode
export const getLocationByBarcode = async (barcode) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/locations/barcode/${barcode}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching location by barcode' };
  }
};

// Get inventory at a location
export const getLocationInventory = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/locations/${id}/inventory`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching location inventory' };
  }
};

// Create new location
export const createLocation = async (locationData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/locations', locationData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error creating location' };
  }
};

// Update location
export const updateLocation = async (id, locationData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(`/api/locations/${id}`, locationData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error updating location' };
  }
};

// Delete location
export const deleteLocation = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/locations/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error deleting location' };
  }
};